import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import appConstants from "../constants/appConstants";
import './StudentSummaryPrintable.css';

const StudentSummaryPrintable = () => {
  const { id } = useParams();
  const [student, setStudent] = useState(null);

  useEffect(() => {
  axios
    .post(
      `${appConstants.API_ROOT_URL}get_student_summary`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    )
    .then((res) => {
      if (res.data.status === "success") {
        const data = res.data.data || res.data.student;
        setStudent(data);

        // Defer printing slightly to allow DOM to render
        setTimeout(() => {
          window.print();
        }, 300);
      } else {
        console.error("Failed to fetch student data:", res.data.message);
      }
    })
    .catch((err) => console.error(err));
}, [id]);


  if (!student) return <p>Loading...</p>;

  const renderCalendar = (monthLabel, data) => {
    const dateMap = {};
    data.days.forEach(day => {
      dateMap[day.date] = day.status;
    });

    const firstDate = new Date(data.days[0].date);
    const year = firstDate.getFullYear();
    const month = firstDate.getMonth();

    const totalDays = new Date(year, month + 1, 0).getDate();
    const firstDayOfWeek = new Date(year, month, 1).getDay();

    const weeks = [[]];
    let currentWeek = weeks[0];

    for (let i = 0; i < firstDayOfWeek; i++) {
      currentWeek.push(
        <td key={`empty-${i}`} style={{ padding: "2px", border: "1px solid #ccc" }}></td>
      );
    }

    for (let d = 1; d <= totalDays; d++) {
      const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      const status = dateMap[dateStr] || "noclass";
      const styles = {
        border: "1px solid #000",
        padding: "2px",
        textAlign: "center",
        fontSize: "9px",
        minWidth: "20px"
      };

      if (status === 'present') {
        styles.backgroundColor = "#AAA";
        styles.color = "#000";
        styles.fontWeight = "bold";
      } else if (status === 'absent') {
        styles.backgroundColor = "#555555";
        styles.color = "#FFF";
      } else {
        styles.textDecoration = "line-through";
        styles.color = "#000";
      }

      currentWeek.push(
        <td key={dateStr} style={styles}>
          {status === 'absent' ? d + ' (A)' : d}
        </td>
      );


      if (currentWeek.length === 7) {
        const newWeek = [];
        weeks.push(newWeek);
        currentWeek = newWeek;
      }
    }

    while (currentWeek.length < 7) {
      currentWeek.push(
        <td key={`end-empty-${currentWeek.length}`} style={{ padding: "2px", border: "1px solid #ccc" }}></td>
      );
    }

    return (
      <div style={{
        flex: 1,
        marginRight: "10px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column"
      }}>
        <div style={{
          textAlign: "center",
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "1.2"
        }}>
          <div>{monthLabel}</div>
          <div style={{ fontSize: "11px", fontWeight: "normal" }}>
            (Present: {data.present}, Absent: {data.absent})
          </div>
        </div>


        <table style={{
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "8px",
  tableLayout: "fixed"
}}>
  <colgroup>
    {[...Array(7)].map((_, i) => (
      <col key={i} style={{ width: "14.28%" }} />
    ))}
  </colgroup>
  <thead>
    <tr>
      {["S", "M", "T", "W", "T", "F", "S"].map((d, idx) => (
        <th key={idx} style={{
          border: "1px solid #000",
          padding: "2px",
          textAlign: "center"
        }}>{d}</th>
      ))}
    </tr>
  </thead>
  <tbody>
    {weeks.map((week, idx) => (
      <tr key={idx}>{week}</tr>
    ))}
  </tbody>
</table>




      </div>
    );
  };

  return (
    <div
  id="printable-container"
  style={{
    padding: "1cm",
    fontFamily: "Arial",
    color: "#000",
    fontSize: "12px",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    justifyContent: "space-between"
  }}
>

    <h3 style={{ textAlign: "center", textTransform: "uppercase" }}>
  Student Report
</h3>
<div style={{ textAlign: "center", fontSize: "18px", marginTop: "-10px" }}>
  ILM CAMPUS - POONOOR
</div>





<section style={{ marginBottom: "20px" }}>
  <h2 style={sectionHeaderStyle}>Basic Information</h2>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "20px" }}>
    
    {/* Column 1: Student Info */}
<div style={{
  width: "320px", // fixed width
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "grid",
  gridTemplateColumns: "110px 1fr",
  rowGap: "8px",
  columnGap: "10px",
  fontSize: "12px"
}}>
  <div style={{ fontWeight: "bold", color: "#000" }}>Name:</div>
  <div style={{ fontWeight: "bold", fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{student.name}</div>

  <div style={{ fontWeight: "bold", color: "#000" }}>Ad. No.:</div>
  <div style={{ fontWeight: "bold", fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{student.admission_no}</div>

  <div style={{ fontWeight: "bold", color: "#000" }}>Class:</div>
  <div style={{ fontWeight: "bold", fontSize: "13px" }}>{student.class_name}</div>

  <div style={{ fontWeight: "bold", color: "#444" }}>Date of Birth:</div>
  <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{student.dob}</div>

  <div style={{ fontWeight: "bold", color: "#444" }}>Gender:</div>
  <div>{student.gender}</div>

  <div style={{ fontWeight: "bold", color: "#444" }}>Parent Name:</div>
  <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{student.parent_name}</div>


  <div style={{ fontWeight: "bold", color: "#444" }}>Address:</div>
  <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{student.address}</div>


  <div style={{ fontWeight: "bold", color: "#444" }}>Phone:</div>
  <div>{student.phone}</div>

  <div style={{ fontWeight: "bold", color: "#444" }}>School:</div>
</div>


    {/* Column 2: Photo */}
    <div style={{ width: "120px", height: "160px", border: "1px solid #000", textAlign: "center", fontSize: "12px" }}>
      {student.photo ? (
        <img
          src={`${appConstants.API_ROOT_URL}uploads/students/${student.photo}`}
          alt="Student"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <span style={{ lineHeight: "180px", color: "#888" }}>No Photo</span>
      )}
    </div>

    {/* Column 3: Fee Details */}
<div style={{ flex: 1 }}>
  <h3 style={{ marginTop: 0, marginBottom: "10px", fontSize: "16px", borderBottom: "1px solid #ccc", fontWeight: "bold" }}>Fee Details</h3>
  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
  <thead>
    <tr>
      <th className="fee-desc-col" style={{ textAlign: "left" }}>Description</th>
      <th className="fee-amnt-col" style={{ textAlign: "right" }}>Amount</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="fee-desc-col">Previous Balance</td>
      <td className="fee-amnt-col" style={{ textAlign: "right" }}>{student.fees?.previous_balance}</td>
    </tr>
    <tr>
      <td className="fee-desc-col">This Year Fees</td>
      <td className="fee-amnt-col" style={{ textAlign: "right" }}>{student.fees?.this_year_fees}</td>
    </tr>
    <tr>
      <td className="fee-desc-col">Total Paid</td>
      <td className="fee-amnt-col" style={{ textAlign: "right" }}>{student.fees?.total_paid}</td>
    </tr>
    <tr style={{ fontWeight: 'bold', backgroundColor: '#bcbcbc', color: '#000' }}>
      <td className="fee-desc-col">Balance</td>
      <td className="fee-amnt-col" style={{ textAlign: "right" }}>{student.fees?.balance}</td>
    </tr>
  </tbody>
</table>

</div>

  </div>
</section>














      <section >
        <h2 style={sectionHeaderStyle} >Attendance (Past 3 Months)</h2>
        <div style={{ display: "flex", gap: "10px" }}>
          {student.attendance && Object.entries(student.attendance).map(([month, data]) => (
            <div key={month}>{renderCalendar(month, data)}</div>
          ))}
        </div>
        <p style={{ fontStyle: "italic", fontSize: "11px", marginTop: "10px" }}>
          <strong>Note:</strong> Grey = Present, Dark = Absent, Strikethrough = No Class
        </p>
      </section>

      <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "20px" }}>
        




<section style={columnSectionStyle}>
  <h2 style={sectionHeaderStyle}>Test Marks</h2>
  <table
    style={{
      ...miniTableStyle,
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "12px"
    }}
  >
    <thead>
      <tr>
        <th style={{ width: "110px", border: "1px solid #000" }}>Test</th>
        <th style={{ width: "100px", border: "1px solid #000" }}>Subject</th>
        <th style={{ textAlign: "right", border: "1px solid #000" }}>Mark</th>
        <th style={{ textAlign: "right", border: "1px solid #000" }}>Max</th>
      </tr>
    </thead>
    <tbody>
      {student.test_marks?.map((mark, idx) => (
        <tr key={idx}>
          <td style={{ border: "1px solid #000" }}>{mark.test_name}</td>
          <td style={{ border: "1px solid #000" }}>{mark.subject_name}</td>
          <td style={{ textAlign: "right", border: "1px solid #000" }}>{mark.mark}</td>
          <td style={{ textAlign: "right", border: "1px solid #000" }}>{mark.total_mark}</td>
        </tr>
      ))}
    </tbody>
  </table>
  <br/>
  <h2 style={sectionHeaderStyle}>Remarks</h2>
</section>






        <section style={columnSectionStyle}>
  <h2 style={sectionHeaderStyle}>Exam Marks</h2>
  <table style={examTableStyle}>
  <thead>
    <tr>
      <th className="subject-col" rowSpan="2" style={examHeaderStyle}>Subject</th>
      {student.exam_marks?.map((exam, idx) => (
        <th key={idx} colSpan="2" style={examHeaderStyle}>
          {exam.term_name}
        </th>
      ))}
    </tr>
    <tr>
      {student.exam_marks?.map((exam, idx) => (
        <React.Fragment key={idx}>
          <th className="mark-col" style={examHeaderStyle}>Scored</th>
          <th className="mark-col" style={examHeaderStyle}>Max</th>
        </React.Fragment>
      ))}
    </tr>
  </thead>
  <tbody>
    {(() => {
      const subjects = new Set();
      student.exam_marks?.forEach(exam => {
        exam.marks.forEach(mark => {
          subjects.add(mark.subject_name);
        });
      });

      return Array.from(subjects).map((subject, idx) => (
        <tr key={idx}>
          <td className="subject-col" style={{ ...examCellStyle, textAlign: "left" }}>{subject}</td>
          {student.exam_marks?.map((exam, eidx) => {
            const mark = exam.marks.find(m => m.subject_name === subject);
            return (
              <React.Fragment key={eidx}>
                <td className="mark-col" style={examCellStyle}>{mark?.mark_scored || '-'}</td>
                <td className="mark-col" style={examCellStyle}>{mark?.max_mark ?? '-'}</td>
              </React.Fragment>
            );
          })}
        </tr>
      ));
    })()}
  </tbody>
  <tfoot>
    <tr>
      <td className="subject-col" style={{ ...examCellStyle, fontWeight: "bold", textAlign: "left" }}>Total</td>
      {student.exam_marks?.map((exam, eidx) => {
        let totalScored = 0;
        let totalMax = 0;
        exam.marks.forEach(mark => {
          const scored = parseFloat(mark.mark_scored);
          if (!isNaN(scored)) totalScored += scored;
          totalMax += mark.max_mark ?? 0;
        });
        return (
          <React.Fragment key={eidx}>
            <td className="mark-col" style={{ ...examCellStyle, fontWeight: "bold" }}>{totalScored}</td>
            <td className="mark-col" style={{ ...examCellStyle, fontWeight: "bold" }}>{totalMax}</td>
          </React.Fragment>
        );
      })}
    </tr>
  </tfoot>
</table>

</section>




      </div>


     {/* Signature */}
<div style={{
  textAlign: "right", // change to right
  fontSize: "12px",
  marginTop: "20px",
  paddingTop: "30px"
}}>
  <div style={{
    width: "160px",
    marginLeft: "auto", // push to the right
    borderTop: "1px solid #000",
    paddingTop: "5px"
  }}>
    Parent / Guardian Signature
  </div>
</div>




    </div>
  );
};




const sectionHeaderStyle = {
  borderBottom: "2px solid #000",
  padding: "4px",
  marginBottom: "5px",
  fontSize: "14px",
  backgroundColor: '#bcbcbc',
  fontWeight: "bold",
  color: '#000'
};

const columnSectionStyle = {
  flex: 1,
  fontSize: "12px"
};

const miniTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  border: "1px solid #000",
  fontSize: "12px"
};

const examTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: "12px",
  marginTop: "10px",
};

const examCellStyle = {
  border: "1px solid #000",
  padding: "3px 5px",
  textAlign: "right",
};

const examHeaderStyle = {
  ...examCellStyle,
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#f0f0f0"
};


export default StudentSummaryPrintable;